import { render, staticRenderFns } from "./FootNav.vue?vue&type=template&id=4824747e"
import script from "./FootNav.vue?vue&type=script&lang=js"
export * from "./FootNav.vue?vue&type=script&lang=js"
import style0 from "./FootNav.vue?vue&type=style&index=0&id=4824747e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports